import { useFont } from '@octane/spark'
import styled from 'styled-components'

export const SectionPrequal = styled.div`
    padding: 0 25px;
    margin-bottom: 10px;
    background-color: ${({ theme }) => theme.colors.monochrome.white};
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.colors.monochrome.concrete};
    display: flex;
    align-items: stretch;

    .column {
        width: 50%;
        padding-top: 25px;
        padding-bottom: 25px;
    }

    .separator {
        width: 1px;
        height: auto;
        margin-left: 20px;
        margin-right: 40px;
        flex: 1 0 auto;
        border-left: 1px solid
            ${({ theme }) => theme.colors.monochrome.concrete};
    }
`

export const Title = styled.h1`
    display: block;
    ${() => useFont('c24', { weight: '800' })};
    color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
    margin-bottom: 5px;
    margin-top: 0;
`

export const RowSubtitle = styled.div`
    display: flex;
    align-items: center;

    button {
        flex-shrink: 0;
    }
`

export const Subtitle = styled.span`
    display: inline-block;
    ${() => useFont('c20', { weight: '400' })};
    color: ${({ theme }) => theme.colors.monochrome.ravenSub};
    margin-right: 15px;
    flex-shrink: 1;
`

export const InputTitle = styled.span`
    display: block;
    ${() => useFont('c14', { weight: '800' })};
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.brand.primary};
`

export const RowInput = styled.div`
    display: flex;
    align-items: center;
    margin-top: 8px;
    gap: 10px;

    #flex-link-input {
        min-width: 280px;
    }

    @media (max-width: 1110px) {
        #flex-link-input {
            min-width: auto;
            flex-grow: 1;
        }

        button {
            width: 190px;
        }
    }
`
